var Tracking = function() {

    // --- 1. DYNAMISK KLICK-LYSSNARE (Event Delegation) ---
    // Denna fångar klicket direkt, oavsett om sidan laddat klart eller inte.
    $("body").on("click", "a[data-epiparam], a[href*='/goto/'], a[href*='/kop-pa/']", function(e) {
        var $el = $(this);
        var currentHref = $el.attr("href");
        
        // Only legacy redirects accept these parameters. Direct affiliate URLs
        // are handled by affiliateEpi.js; never append to their destination URL.
        if (/\/goto\/|\/kop-pa\//.test(currentHref || "")) {
        // Hämta GCLID från webbläsarens adressfält
        var urlParams = new URLSearchParams(window.location.search);
        var gclid = urlParams.get('gclid');
        var gbraid = urlParams.get('gbraid');
        var wbraid = urlParams.get('wbraid');
        
        // Hämta Client ID från GA eller Cookie
        var clientId = "";
        try {
            if (typeof gtag !== "undefined" && typeof ga !== "undefined") {
                clientId = ga.getAll()[0].get("clientId");
            }
        } catch(err) {
            var match = document.cookie.match(/_ga=GA1\.\d+\.(\d+\.\d+)/);
            clientId = match ? match[1] : "";
        }

        // Bygg om URL:en med URL-objektet (säkrare än sträng-pussel)
        var url = new URL(currentHref, window.location.origin);
        
        // Sätt parametrarna som din OutLinkNewController förväntar sig
        if (gclid) url.searchParams.set("gclid", gclid);
        if (gbraid) url.searchParams.set("gbraid", gbraid);
        if (wbraid) url.searchParams.set("wbraid", wbraid);
        if (clientId) url.searchParams.set("gcid", clientId);
        if (!url.searchParams.has("ref")) url.searchParams.set("ref", "kostnord.se");
        
        // Uppdatera elementets href precis innan navigeringen sker
        this.href = url.toString();
        }

        // Skicka GA-event (Add to cart tracking för gamla strukturen)
        var parent = $el.closest("[data-providerid]");
        var product = $el.closest("[data-productid]");
        var salesId = parent.attr("data-providerid");
        var name = parent.attr("data-name") || product.attr("data-name") || "";
        var price = Number(parent.attr("data-price") || product.attr("data-price") || 0);
        if (typeof gtag === "function" && /^[1-9][0-9]*$/.test(salesId || "")) {
            var category = window.location.pathname.replace(/\/+$/, "").split("/").pop();
            gtag('event', 'add_to_cart', {
                currency: $("body").data("currency"),
                value: isFinite(price) ? price : 0,
                transport_type: 'beacon',
                items: [{
                    'item_id': 'SKU_' + salesId,
                    'item_name': name.replace(/\+|\*|\%|\,|\.|\&/g, ""),
                    'item_category': category,
                    'item_brand': name.split(" ")[0],
                    'quantity': 1,
                    'product_id': product.attr("data-productid") || "",
                    'price': isFinite(price) ? price : 0,
                }]
            });
        }
    });

    // --- 2. INITIALISERING (View Item) ---
    //
    // Här låg tidigare ett pass som hängde på gclid/gbraid/wbraid som egen
    // parameter sist i köp-länkens URL. Det skrevs när länkarna gick via
    // /goto/, där OutLinkNewController läste parametern och byggde epi-strängen
    // av den. Nu står affiliate-URL:en direkt i href, och nätverken (Adtraction,
    // awin, tradedoubler, partner-ads) lägger destinationen sist i sin egen
    // query — "&url=https://butiken.se/produkt". Ett påhängt "&gclid=..." hamnade
    // därför INUTI destinationen och skickade besökaren till en adress som inte
    // finns hos butiken.
    //
    // Attributionen sköts numera helt via epi och epi2 i affiliateEpi.js, som
    // bygger på epi-värdet på plats och aldrig rör resten av URL:en.
    function initTracking() {
        if (typeof gtag !== "function") return;
        $("[data-productid]").each(function(index) {
            var $product = $(this);
            if (!$product.data("name") || !$product.data("providerid")) return;

            // View Item tracking (Körs när elementet syns/laddas)
            gtag('event', 'view_item', {
                items: [{
                    'item_id': 'SKU_' + $product.data("providerid").toString(),
                    'item_name': $product.data("name").toString().replace(/\+|\*|\%|\,|\.|\&/g, ""),
                    'item_category': window.location.pathname.replace(/\/+$/, "").split("/").pop(),
                    'item_brand': $product.data("name").split(" ")[0],
                    'position': index + 1,
                    'dimension1': $product.data("providerid").toString()
                }]
            });
        });
    }

    // --- 3. KÖR KODEN SÅ SNABBT SOM MÖJLIGT ---
    // Vi väntar inte på window.load (bilder), utan kör så fort HTML-strukturen är klar.
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initTracking);
    } else {
        initTracking();
    }

    // Sök-tracking
    $(".search-icon").on("click", function(){
        if (typeof gtag !== "function") return;
        gtag('event', 'Search', {
            eventAction: 'TopMenu',
            eventLabel: "Search",
            eventValue: 1
        });
    });
};

module.exports = Tracking;
